import {
	createComponentExtension,
	createPlugin,
} from '@backstage/core-plugin-api';

export const teamMetadataPlugin = createPlugin({
	id: 'team-metadata',
});

export const EntityTeamMetadataCard = teamMetadataPlugin.provide(
	createComponentExtension({
		name: 'EntityTeamMetadataCard',
		component: {
			lazy: () =>
				import('./components/TeamMetadataCard').then(
					m => m.EntityTeamMetadataCard,
				),
		},
	}),
);
